<app-widget [widget-meta]="this.data">
    <p>The widget {{ this.data.meta.Name }} is unavailable.</p>
</app-widget>
